import { createFileRoute } from '@tanstack/react-router'
import { GeneralSettings } from '@/features/settings/ui/general-settings'

export const Route = createFileRoute('/_authenticated/account/')({
	component: GeneralPage,
})

function GeneralPage() {
	return <GeneralSettings />
}
